export function AuthLoader() {
    const theme = localStorage.getItem('theme') || localStorage.getItem('themeConfig');
    const isDark = theme === 'dark' ||
        theme === '"dark"' ||
        (theme?.includes('dark')) ||
        ((!theme || theme === 'system' || theme === '"system"') && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches);

    return (
        <div
            role="status"
            aria-live="polite"
            aria-busy="true"
            className={`fixed inset-0 z-[60] flex items-center justify-center overflow-hidden font-nunito transition-colors duration-200 ${isDark ? 'dark bg-[#060818]' : 'bg-[#fafafa]'}`}
        >
            {/* Ambient glow */}
            <div className="pointer-events-none absolute inset-0 flex items-center justify-center" aria-hidden="true">
                <div className="h-[420px] w-[420px] rounded-full bg-gradient-to-br from-primary/25 via-primary-light/10 to-transparent blur-3xl" />
            </div>

            <div className="relative flex flex-col items-center gap-8">
                <div className="flex h-24 w-24 items-center justify-center rounded-3xl border border-white/30 bg-white/70 shadow-soft-lg backdrop-blur-md dark:border-white/10 dark:bg-black/40">
                    <img
                        src="/assets/images/logo-green.svg"
                        alt=""
                        aria-hidden="true"
                        className="w-12 animate-pulse motion-reduce:animate-none"
                    />
                </div>
                <div className="flex items-center gap-2.5" aria-hidden="true">
                    <span className="h-2.5 w-2.5 animate-bounce motion-reduce:animate-none rounded-full bg-primary" style={{ animationDelay: '0ms' }} />
                    <span className="h-2.5 w-2.5 animate-bounce motion-reduce:animate-none rounded-full bg-secondary" style={{ animationDelay: '150ms' }} />
                    <span className="h-2.5 w-2.5 animate-bounce motion-reduce:animate-none rounded-full bg-pale-green" style={{ animationDelay: '300ms' }} />
                </div>
            </div>

            <span className="sr-only">Loading</span>
        </div>
    );
}
